import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const FeatureCaseStudy = ({ data }) => {
  const { link, desc, title, sideNote, img, hasLine = true } = data;

  return (
    <div className="case-study">
      <Container>
        <a href={link} target="_blank" rel="noopener" className="font-white a-no-underline">
          <Container className="py-5" fluid>
            <Row>
              <Col>
                <div className="case-title mb-4">
                  {"Read our case studies"}
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12} lg={9} className="case-col-padding-right">
                <div className="featured-case">
                  <Row className={`${hasLine ? "border-bottom-white" : ""}`}>
                    <Col xs={12} lg={6}>
                      <div>
                        <div className="title mb-4">
                          {title}
                        </div>
                        <div className="case-desc mb-4">
                          {desc}
                        </div>
                        <button target="_blank" rel="noopener" className="mb-4 btn btn-green btn-long py-2">
                          {"Read more"}
                        </button>
                      </div>
                    </Col>
                    <Col xs={12} lg={6}>
                      {img && <img className="featured-case-img" src={img} alt={title} />}
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col xs={12} lg={3} className="case-col-padding-left">
                <div className="featured-case p-0">
                  <div className="case-desc block-center max-width-360 side-note">
                    {sideNote}
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </a>
      </Container>
    </div>
  );
}

export default FeatureCaseStudy;